export const GET_ALL_DISCOUNT_SUMMARY = 'GET_ALL_DISCOUNT_SUMMARY'
export const GET_ALL_DISCOUNT_SUMMARY_SUCCESS = 'GET_ALL_DISCOUNT_SUMMARY_SUCCESS'
export const SET_SUMMARY_PRODUCT_LOADING = 'SET_SUMMARY_PRODUCT_LOADING'
export const GET_DISCOUNT_SUMMARY_ERROR='GET_DISCOUNT_SUMMARY_ERROR'